import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'

import {trans} from '@utils'

import Statistic from "../Statistic"

const StatisticAverageScore = props => {
  const {
    initOnMount = false,
    uri = null,
    withChart = true,
    chartType = 'area',
    vertical = false,
    height = 100,
    skeletonMinHeight
  } = props
  const {value, loading, stats} = useSelector(store => _.get(store, 'analytics.data.statistics_unique_auditors'))

  const dispatch = useDispatch()

  useEffect(() => {
    if (initOnMount) {
      // _getTotalUniqueAuditors(uri)
    }
    return () => {
      // dispatch({
      //   type: 'ANALYTICS_CHARTS_DATA',
      //   payload: {
      //     total_unique_auditors: {
      //       value: 0,
      //       loading: true,
      //       stats: []
      //     }
      //   }
      // })
    }
  }, [])

  const options = {
    tooltip: {
      y: {
        formatter (y) {
          if (typeof y !== "undefined") {
            return `${y.toFixed(0)}`
          }
          return y
        },
        title: {
          formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
            return ''
          }
        }
      }
    }
  }

  return (
    <Statistic
      title={trans('analytics.actions.uniqueAuditors')}
      color={'danger'}
      data={stats}
      stats={value}
      // icon={<User />}
      withChart={withChart}
      chartType={chartType}
      vertical={vertical}
      loading={loading}
      height={height}
      skeletonMinHeight={skeletonMinHeight}
      options={options}
    />
  )
}

StatisticAverageScore.propTypes = {}

export default StatisticAverageScore
